<section class="salesProperties">
  <div class="container">
    <div class="heading text-center">
      <div class="">
        <h3>Sold PROPERTIES IN ALWAR</h3>
      </div>
      <div class="">
        <p>Take a look at our current trending properties.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-11 col-lg-9 col-xl-8 mx-auto main-search">
        <form [formGroup]="propertySearch">
          <div class="row selector">
            <div class="selecotr-item ">
              <input type="radio" id="all" class="selector-item_radio"
                [checked]="propertySearch.value.looking_type=='all'" formControlName="looking_type" value="all">
              <label for="all" class="selector-item_label py-md-2 rounded-pill m-0 ">All</label>
            </div>
            <div class="selecotr-item ">
              <input type="radio" id="residential" class="selector-item_radio"
                [checked]="propertySearch.value.looking_type=='residential'" formControlName="looking_type"
                value="residential">
              <label for="residential" class="selector-item_label py-md-2 rounded-pill m-0">Residential</label>
            </div>
            <div class="selecotr-item ">
              <input type="radio" id="commercial" class="selector-item_radio"
                [checked]="propertySearch.value.looking_type=='commercial'" formControlName="looking_type"
                value="commercial">
              <label for="commercial" class="selector-item_label py-md-2 rounded-pill m-0">Commercial</label>
            </div>
            <div class="selecotr-item ">
              <input type="radio" id="agriculture" class="selector-item_radio"
                [checked]="propertySearch.value.looking_type=='agriculture'" formControlName="looking_type"
                value="agriculture">
              <label for="agriculture" class="selector-item_label py-md-2 rounded-pill m-0">Agriculture</label>
            </div>
            <div class="selecotr-item ">
              <input type="radio" id="industrial" class="selector-item_radio"
                [checked]="propertySearch.value.looking_type=='industrial'" formControlName="looking_type"
                value="industrial">
              <label for="industrial" class="selector-item_label py-md-2 rounded-pill m-0">Industrial</label>
            </div>
          </div>
          <div class="row search-propetiles mt-4">
            <div class="col-8 col-md-10 col-lg-10 col-xl-10 p-0">
                <div class="sale-search">
                  <input type="text" placeholder="search Sale Properties" ngx-google-places-autocomplete
                    [value]="propertySearch.value.location" (keyup)="handleAddressChange($event,'mannual')"
                    (onAddressChange)="handleAddressChange($event,'address')" [options]="options">
                  <i class="ti-location-pin"></i>
                </div>
            </div>
            <div class="col-4 col-md-2 col-lg-2 col-xl-2 p-0">
              <div class="sale-search">
                <button class="search-btn" (click)="searchProperty()"><i
                    class="ti-search"></i><span>Search</span></button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <app-matloader *ngIf="listingLoader"></app-matloader>
    <div class="col-md-8 col-12 pd 0" *ngIf="soldProperties.length==0">
      <div class="col-md-12 col-12 no-result-found center-result">
        <img alt="transparent" src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          data-src="assets/images/property-not-found.png" class="img-fluid" style="height:200px">
        <p>No results matching your search!<br>
          <small>Try removing some of the filters to get matching propertyresults</small>
        </p>
      </div>
    </div>

    <div class="row" *ngIf="soldProperties.length>0" infinite-scroll [infiniteScrollDistance]="scrollDistance"
      [infiniteScrollThrottle]="throttle" (scrolled)="getAllSalesProperty()">

      <div class="col-lg-3 col-xl-3 col-md-4 col-sm-6 col-12 pdl" *ngFor="let sold of soldProperties; let i=index;">
        <div class="propria-prop-content">
          <figure>
            <div class="carousel slide" data-interval="false" data-ride="carousel" id="demoW{{i}}">
              <div class="carousel-inner">
                <div class="carousel-item active" *ngFor="let image of sold.images;let first=first;"
                  [ngClass]="{active: first}">

                  <img lazyLoad="{{ image.img_path }}" defaultImage="assets/images/propira-default.webp"
                    class="img-fluid" alt="listing image" style="width: 100%">
                </div>

                <div class="carousel-item">
                  <img alt="listing image" class="img-fluid" defaultimage="assets/images/propira-default.webp"
                    style="width: 100%" src="assets/images/propira-default.webp">
                </div>
              </div>
              <a class="carousel-control-prev" data-slide="prev" href="#demoW{{i}}" *ngIf="sold.images.length>1">
                <i class="ti-angle-left"></i>
              </a>
              <a class="carousel-control-next" data-slide="next" href="#demoW{{i}}" *ngIf="sold.images.length>1">
                <i class="ti-angle-right"></i>
              </a>
            </div>
            <div class="ribbon verified">
              <span>For Rent</span>
            </div>
            <div class="image-overlay"></div>
            <span class="list-loc">
              <i class="ti-location-pin"></i>
              {{sold.location}}
            </span>
            <span class="media-file"><i class="fa fa-play" *ngIf="sold.video"></i> <i class="ti-camera"></i>
              {{sold.images.length}}</span>
          </figure>
          <div class="propria-body">
            <a target="_blank" href="{{ sold.property_slug }}">
              <h6 class="names-propria" data-placement="left" data-toggle="tooltip"
                title="{{sold.property_title | titlecase}}"> {{sold.property_title | titlecase}} </h6>
            </a>
            <p>
              <b>₹{{sold.priceinshort_words}}</b>&nbsp;&nbsp;
              <b>₹{{sold.priceper_unitvalue}}</b>
            </p>
            <div class="flats-catego by-build">
              <a target="_blank" href="{{ sold.property_slug }}">See Details</a>
              <div class="listing_actions">
                <div class="share_unit">
                  <ul class="min-shear">
                    <li class=""><a href="javascript: void(0);"><i class="fa  fa-google"></i></a></li>
                    <li class=""><a href="javascript: void(0);"><i class="ti-facebook"></i></a></li>
                    <li class=""><a href="javascript: void(0);"><i class="ti-instagram"></i></a></li>
                    <li class=""><a href="javascript: void(0);"><i class="fa fa-whatsapp"></i></a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="property-agent">
              Posted on {{sold.posted_date}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-12 p-4 mp0">
        <ngx-spinner bdOpacity=0.9 bdColor="" size="default" color="#db0c0c" type="ball-pulse-sync"
          [fullScreen]="false">
        </ngx-spinner>
      </div>
    </div>
  </div>
</section>